import React, {createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState} from 'react';
import {
    authData,
    filtersData,
    filtersVisible,
    listAdminModulesActions as listAdminModulesActionsStorage
} from "../Storages";
import getInitialDataFilter from "../Components/PageFilters/initialDataFilter";
import {IFilter} from "../Components/PageFilters/types";
import {listAdminModulesActions as listAdminModulesActionsRequest} from "../Requests";
import {Request} from "../Requests/request";

interface IProps {
    children: ReactNode
}

interface IGlobalProvider {
    filters?: IFilter;
    setFilters?:  Dispatch<SetStateAction<IFilter>>;
    showFilters?: boolean;
    setShowFilters?: Dispatch<SetStateAction<boolean>>;
    loading?: boolean;
    setLoading?: Dispatch<SetStateAction<boolean>>;
    listAdminModulesActions?: string[];
    updateListAdminModulesActions?: (requestWrapper?: (request: Request) => Request) => Promise<any>
}

let GlobalContext = createContext<IGlobalProvider>({});

const GlobalProvider: React.FC<IProps> = ({ children }) => {

    if(Object.keys(filtersData.get() || {}).length === 0) {
        filtersData.save(getInitialDataFilter());
    }

    if(Object.keys(filtersVisible.get() || {}).length === 0) {
        filtersVisible.save({visible: false});
    }

    const [filters, setFilters] = useState<IFilter>(filtersData.get());
    const [showFilters, setShowFilters] = useState<boolean>(filtersVisible.get()?.visible);
    const [loading, setLoading] = useState<boolean>(false);
    const [listAdminModulesActions, setListAdminModulesActions] = useState<string[]>(listAdminModulesActionsStorage.get())

    const updateListAdminModulesActions = async (requestWrapper: ((request: Request) => Request) | undefined) => {
        if (!requestWrapper) {
            requestWrapper = (r: Request) => r;
        }
        const result = await requestWrapper(listAdminModulesActionsRequest).get(authData.get().access_profile_id + '');
        listAdminModulesActionsStorage.save(result);
        setListAdminModulesActions(result);
    }

    useEffect(() => {
        filtersData.save(filters);
    }, [filters])

    useEffect(() => {
        filtersVisible.save({visible: showFilters});
    }, [showFilters])


    const contextValue = {
        filters,
        setFilters,
        showFilters,
        setShowFilters,
        loading,
        setLoading,
        listAdminModulesActions,
        updateListAdminModulesActions
    };

    return (
        <GlobalContext.Provider value={contextValue}>
            {children}
        </GlobalContext.Provider>
    );
};

export {
    GlobalContext,
    GlobalProvider
}
